module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default"), _vm._v(" "), _c('div', {
    attrs: {
      "id": "contain-head"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "top-contain"
    }
  }, [_c('div', {
    staticClass: "top-total"
  }, [_c('span', [_c('a', {
    class: _vm.classArray[0],
    on: {
      "click": function($event) {
        _vm.order(0, _vm.orderEmon.NORMAL)
      }
    }
  }, [_vm._v("推荐")])]), _vm._v(" "), _c('span', [_c('a', {
    class: _vm.classArray[1],
    on: {
      "click": function($event) {
        _vm.order(1, _vm.orderEmon.SALENUM)
      }
    }
  }, [_vm._v("销量")])]), _vm._v(" "), _c('span', [_c('a', {
    class: _vm.classArray[2],
    on: {
      "click": function($event) {
        _vm.order(2, _vm.orderEmon.CHAOZHI)
      }
    }
  }, [_vm._v("超值")])]), _vm._v(" "), _c('span', [_c('a', {
    class: _vm.classArray[3],
    on: {
      "click": function($event) {
        _vm.order(3)
      }
    }
  }, [_vm._v("价格"), _c('span', [_c('img', {
    class: _vm.arrayClass,
    attrs: {
      "src": _vm.imgArray
    }
  })])])]), _vm._v(" "), _c('span', {
    class: _vm.filterClass,
    on: {
      "click": _vm.filter
    }
  }, [_vm._v("筛选")]), _vm._v(" "), _c('v-filter', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.public.filterBody),
      expression: "public.filterBody"
    }],
    attrs: {
      "resert": _vm.public.resert
    }
  })], 1)])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c624af1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Top.vue
// module id = 202
// module chunks = 2